export default {
    topics: [
        {
            title: 'Controls',
            href: 'control-Button.html',
            menu: { hasChildren: true },
            tocID: 'tocId-d66e7889',
            next: 'tocId-d66e7889',
        },
    ],
};

